<script>
    import { navigate }    from "svelte-routing"
    import CompanyDropdown from './shared/CompanyDropdown.svelte'
    import { companyChanged } from './shared/utils.js'

    import {
        companyId,
        company, 
    }  from './shared/stores.js'
    
    export let onLogoff

    $: enabled = $company && $company.id

    let mode = $company && $company.name ? '' : 'edit'
    
    const actions = [
        { always: false, enabled: true, text: 'Pedidos de Titulares'   , link: '/pedidos'        },    
        { always: false, enabled: true, text: 'Atividades'             , link: '/atividades'     },
        { always: false, enabled: true, text: 'Perfis'                 , link: '/perfis'         },
        { always: false, enabled: true, text: 'Dados e Lugares'        , link: '/lugares'        },
        { always: false, enabled: true, text: 'Operadores'             , link: '/operadores'     },
        { always: false, enabled: true, text: 'Central da Privacidade' , link: '/sites'          },
        { always: false, enabled: true, text: 'Consentimentos'         , link: '/consentimentos' },
        { always: false, enabled: true, text: 'Cookies'                , link: '/cookies'        },
        { always: true , enabled: true, text: 'Empresas'               , link: '/empresas'       },
        { always: false, enabled: true, text: 'Usuários'               , link: '/usuarios'       },
        { always: false, enabled: true, text: 'DPOs'                   , link: '/dpos'           },
    ]

    let active = null
    const match = /empresa\/([0-9]+)\/(.+)/.exec(window.location)
    if(match) {
        const section = '/' + match[2]
        active = actions.find(it => section.startsWith(it.link))
    }

    function goto(action) {
        if(action.always || (enabled && action.enabled)) {
            active = action
            if('/empresas' === action.link) {
                navigate('/empresas')
            } else {
                const id = $company.id
                navigate(`/empresa/${id}${action.link}`)
            }
        }
    }
</script>
<style>
    .company {
        margin: 0 1em;
    }

    .link {
        cursor: pointer;
        font-size: 14pt;
    }

    .link.disabled {
        color: #ccc;
    }

    .item {
        color   : white;
        padding : .5em 1em;
        margin  : .5em 1em;
    }

    .item.active, .item:hover {
        background-color: rgba(255,255,255,.3);
        border-radius: 8px;
        /* border-color:#2185d0 !important; */
    }

    .menu {
        display: flex;
        flex-direction: column;
        margin: 10px auto;
        /* border: 1px solid red; */
    }

    .logo {
        width: 200px;
        margin: 60px auto 20px auto;
    }
    .logo img {
        width: 200px;
    }

    .company {
        margin: 0 auto;
        width: min-content;
    }
    
</style>
<div class="logo">
    <img src="/logo-h.png" alt="Dogma"/>
</div>
<div>
    <div class="company">
        <CompanyDropdown
            onChange={selected => {
                mode   = ''
                active = null
                $companyId = companyChanged(selected)
            }}
            onCancel={() => mode = ''} />
    </div>
</div>

<div class="menu">
    {#each actions as action, i}
        <span   class="ui item link { action.always || (enabled && action.enabled) ? '': 'disabled'}"
                class:active={active && active.text === action.text}
                on:click={e => goto(action) }>
            {action.text}</span>
    {/each}
</div>